import { toast } from 'react-toastify';
import { submitData } from '../../ApiServices/ProductServices';

export const addItemToCart =
  (product, token, showAlert = true) =>
  dispatch => {
    if (showAlert) {
      toast.success('Added to cart.');
    }
    return dispatch({ type: 'ADD_CART_ITEM', payload: { product, token, dispatch } });
  };

export const removeCartItem = (product, token) => dispatch => {
  toast.warning('Removed from cart.');
  return dispatch({ type: 'REMOVE_CART_PRODUCT', payload: { product, token, dispatch } });
};

export const saveUserCartProducts = (token, values, id) => dispatch => {
  submitData('saveCartProducts', token, { products: values }, id)
    .then(response => {})
    .catch(error => {});
};
